export default __webpack_public_path__ + "static/exodiafinance-dcc57bf91ec86f26f5c33dbbe7d88c0e.jpg";